import type { ColumnDef } from "@tanstack/react-table"

import type { PriceChangeRecipient } from "@/graphql/codegen/graphql"

export const usePriceChangeRecipientsColumns = (): ColumnDef<PriceChangeRecipient>[] => {
  return [
    {
      accessorKey: "companyName",
      header: "Company Name",
      cell: ({ row }) => row.original.companyName,
      minSize: 120,
      enableSorting: false,
    },
    {
      accessorKey: "contactName",
      header: "Contact Name",
      cell: ({ row }) => row.original.contactName,
      minSize: 120,
      enableSorting: false,
    },
    {
      accessorKey: "email",
      header: "Email",
      cell: ({ row }) => row.original.email,
      minSize: 120,
      enableSorting: false,
    },
  ]
}
